import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import TimeRemaining from 'components/TimeRemaining'

import type { TimeRemainingProps } from 'components/TimeRemaining'
import type { FC } from 'react'

interface BlockTimeRemainingProps extends TimeRemainingProps {
  className?: string
}

const BlockTimeRemaining: FC<BlockTimeRemainingProps> = ({
  endTime,
  className,
  ...props
}) => {
  return (
    <div
      className={clsx('bg-surface-warning-subdued p-3 rounded-lg', className)}
    >
      <Text variant="body">
        Waktu pengisian ujian tersisa{' '}
        <TimeRemaining endTime={endTime} {...props} />
      </Text>
    </div>
  )
}
export default BlockTimeRemaining
